import { useEffect, useState } from "react";
import { osApi, timeAgo } from "./osApi";
import { toast } from "sonner";
import { PhoneCall } from "lucide-react";

const STATUS_COLORS = { Missed: "os-badge-red", Connected: "os-badge-green", "Follow-up": "os-badge-amber", Converted: "os-badge-green" };

export default function OSCalls() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { osApi.listCalls().then(r => setItems(r.items)).catch(() => toast.error("Failed")).finally(() => setLoading(false)); }, []);
  return (
    <div className="space-y-5" data-testid="os-calls-page">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Call Tracking</h1>
        <p className="text-sm mt-1" style={{color:"var(--os-text-muted)"}}>Every incoming call, every source, every agent — logged.</p>
      </div>
      <div className="os-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="os-table">
            <thead><tr><th>When</th><th>Caller</th><th>Agent</th><th>Source</th><th>Duration</th><th>Status</th></tr></thead>
            <tbody>
              {loading && <tr><td colSpan={6} className="text-center py-10" style={{color:"var(--os-text-muted)"}}>Loading…</td></tr>}
              {!loading && items.length === 0 && <tr><td colSpan={6} className="text-center py-10" style={{color:"var(--os-text-muted)"}}>No calls logged yet. Real numbers pipe in from the Call Tracking Kit (setup pending).</td></tr>}
              {items.map(c => (
                <tr key={c.id} data-testid={`os-call-row-${c.id}`}>
                  <td className="text-xs">{timeAgo(c.created_at)}</td>
                  <td>{c.caller_name || "—"}</td>
                  <td>{c.agent_name || "—"}</td>
                  <td><span className="os-badge os-badge-blue">{c.source || "—"}</span></td>
                  <td className="os-mono">{c.duration_secs}s</td>
                  <td><span className={`os-badge ${STATUS_COLORS[c.status] || "os-badge-grey"}`}>{c.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="os-card p-4 text-xs" style={{color:"var(--os-text-muted)"}}>
        <PhoneCall className="w-4 h-4 inline mr-2" />
        <strong>Note:</strong> Call recording integration is provisioned. Wire your provider (Exotel / Knowlarity / Twilio) to <code className="os-mono">POST /api/ofr/calls</code> to start streaming call logs here.
      </div>
    </div>
  );
}
